import anime from 'animejs';

/**
 * Alternates the ISC logo with the #GUFA26 tag at the left end of the bar: 1.5 s fade,
 * 30 s hold, forever. Reads nothing from the API and takes no part in the infobar cycle
 * — it just needs starting once.
 */
export const logoCrossFade = {
    logoCrossFadeDelay: 30000,
    logoCrossFadeDuration: 1500,

    logoIdNextMapping: {
        'isc-logo': 'guf-tag',
        'guf-tag': 'isc-logo',
    },

    fadeInLogo: (logoId) => {
        const logoElementId = logoId;
        const nextLogoId = logoCrossFade.logoIdNextMapping[logoId];
        anime({
            targets: ['#' + logoElementId, '#' + nextLogoId],
            opacity: function (el, i) {
                const opacityValue = i === 0 ? 1 : 0;
                return opacityValue;
            },
            easing: 'easeInOutQuad',
            duration: logoCrossFade.logoCrossFadeDuration,
            endDelay: logoCrossFade.logoCrossFadeDelay,
            complete: function () {
                logoCrossFade.fadeInLogo(nextLogoId);
            }
        });
    }};

window.logoCrossFade = logoCrossFade;
